import { gql } from '@apollo/client';

export const fetchProductIdOfferingIds = gql`
  query fetchProductIdOfferingIds(
    $id: ID!
    $filterOptions: [FilterOption]
    $offeringFilter: [FilterOption]
    $isAddOnsSearchEnabled: Boolean
  ) {
    nativeCatalogItem: partnerNativeCatalogItem(id: $id, isAddOnsSearchEnabled: $isAddOnsSearchEnabled) {
      id
      offering(filterOptions: $offeringFilter) {
        id
        offeringName
        pricingType
        availablePricingPlans(filterOptions: $filterOptions) {
          type
          billingFrequency
          updatedAt
          id
          currency
          pricingPlanType
          status
          description
          tiers {
            floor
            ceiling
            amount
            unitAmount
            flatAmount
          }
        }
        relationshipRequirements {
          level
          side
          type
        }
        trialLengthInDays
        offeringGroup
      }
    }
  }
`;
